<template lang="pug">
l-control(class="custom-center-control" :position="position")
  v-toolbar(dense floating :style="{height: collapsed ? '48px!important' : '60px!important'}")
    v-row(class="pt-6 pl-2" v-if="!collapsed")
      v-autocomplete(
        style="z-index:2000"
        :loading="loading"
        :search-input.sync="searchLocation"
        v-model="selectedLocation"
        :items="locations"
        item-text="label"
        prepend-icon="mdi-magnify"
        hide-details
        label="Buscar lugar en el mapa"
        clearable
        @change="goLocation")
      v-btn(icon title="Contraer control" @click="collapsed = true")
        v-icon mdi-arrow-expand-left
    v-btn(v-else icon title="Expandir control" @click="collapsed = false")
      v-icon mdi-magnify
</template>

<script>
import { LControl } from 'vue2-leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import debounce from 'debounce';

const provider = new OpenStreetMapProvider();

export default {
  name: 'GeoSearchControl',

  components: {
    LControl,
  },

  props: {
    // el map en el cual esta renderizado el componente
    map: {
      type: Object,
      required: true
    },
    // posicion del control con los valores permitiod de leaflet
    position: {
      type: String,
      default: 'topleft',
      validator(value) {
        return ['topright', 'topleft', 'bottomright', 'bottomleft'].includes(value);
      }
    }
  },

  data() {
    return {
      // esatdo con el criterio d ela busqueda
      searchLocation: '',
      // estado con la seleccion actual
      selectedLocation: null,
      // estado para almacenar los lugares
      locations: [],
      // estado para indicar que l componente esta cargando
      loading: false,
      // estado que indica si el control esta colapsado
      collapsed: false,
    };
  },

  computed: {
  },

  watch: {
    searchLocation() {
      if ([null, undefined, ''].includes(this.searchLocation)) {
        this.locations = [];
        return;
      }
      this.debounceSearch();
    },
  },

  methods: {
    // metodo para manejar el debounde
    debounceSearch: debounce(async function deb() {
      this.geoSearch();
    }, 500),
    // metodo para taer los resultada
    async geoSearch() {
      this.loading = true;
      const results = await provider.search({ query: this.searchLocation });
      this.locations = results;
      this.loading = false;
    },
    // meodo para ir a la locacion especifica
    goLocation(e) {
      if ([null, undefined, ''].includes(this.searchLocation)) return;
      const location = this.locations.filter((x) => x.label === e)[0];
      this.map.fitBounds(location.bounds);
    }
  }
};
</script>

<style scoped>
/* .v-sheet.v-toolbar.v-toolbar--dense {
  height: 60px!important;
} */
</style>
